<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!addressSelected) {
        <h1 class="title">Crear dirección</h1>
      }
    </div>
    <div class="title-color">
      @if (addressSelected) {
        <h1 class="title">Editar dirección</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="addressForm" (ngSubmit)="saveAddress()">
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Barrio/vereda</mat-label>
              <input
                type="text"
                matInput
                placeholder="Barrio/vereda"
                formControlName="street"
                maxlength="100"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (addressForm.get('street')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (addressForm.get('street')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 100 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Número</mat-label>
              <input
                type="text"
                matInput
                placeholder="Número"
                formControlName="number"
                maxlength="10"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (addressForm.get('number')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (addressForm.get('number')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 10 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Complemento</mat-label>
              <input
                type="text"
                matInput
                placeholder="Complemento"
                formControlName="complement"
                required
                maxlength="100"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (addressForm.get('complement')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (addressForm.get('complement')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 100 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Código de Territorio</mat-label>
              <input
                type="text"
                matInput
                placeholder="Código de Territorio"
                formControlName="territoryCode"
                required
                maxlength="10"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (addressForm.get('territoryCode')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (addressForm.get('territoryCode')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 10 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Territorio</mat-label>
              <input
                type="text"
                matInput
                placeholder="Territorio"
                formControlName="territory"
                required
                maxlength="100"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (addressForm.get('territory')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (addressForm.get('territory')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 100 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Código de Autoridad</mat-label>
              <input
                type="text"
                matInput
                placeholder="Código de Autoridad"
                formControlName="authorityCode"
                required
                maxlength="10"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (addressForm.get('authorityCode')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (addressForm.get('authorityCode')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 10 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Autoridad</mat-label>
              <input
                type="text"
                matInput
                placeholder="Autoridad"
                formControlName="authority"
                required
                maxlength="100"
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (addressForm.get('authority')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (addressForm.get('authority')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 100 caracteres
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!addressForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
